import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Smart brand-name renderer.
 * Splits the brand name on the first space and colors the rest red,
 * giving "FAT" + "BUSTERS" the signature two-tone look.
 * If the name is one word, the whole thing is white.
 */
const SplitName = ({ name }) => {
  const parts = (name || '').trim().split(/\s+/);
  if (parts.length === 1) return <span>{parts[0]}</span>;
  const [first, ...rest] = parts;
  return (
    <>
      {first} <span className="text-red-500">{rest.join(' ')}</span>
    </>
  );
};

/**
 * Text-only brand wordmark — no icon.
 * The visual brand identity lives in the home-page hero banner.
 *
 * Props:
 *   name     - the CMS-driven brand name (falls back to "FAT BUSTERS")
 *   variant  - "light" (header on white bg) | "dark" (sign-in screen)
 *   className
 */
export const BrandLogo = ({ name = 'FAT BUSTERS', className = '', variant = 'light' }) => (
  <Link to="/" className={`group ${className}`} data-testid="brand-logo">
    {variant === 'dark' ? (
      <span className="text-white font-extrabold text-2xl sm:text-3xl tracking-tight" style={{ textShadow: '0 0 20px rgba(239,68,68,.35)' }}>
        <SplitName name={name} />
      </span>
    ) : (
      <span className="text-[#0a0a0a] font-extrabold text-lg sm:text-xl tracking-tight">{name}</span>
    )}
  </Link>
);

export const BrandLogoOnDark = ({ name = 'FAT BUSTERS' }) => (
  <span className="text-white font-extrabold text-lg tracking-tight">{name}</span>
);

export default BrandLogo;
